import { combineReducers } from 'redux';
import ssnDetails from './addMember/ssnDetailsReducer';

export default combineReducers({
    ssnDetails,
});
